import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
    apiKey: "AIzaSyCGQabM-XskhR0IAv5RMDKItyd8v0QYZjE",
    authDomain: "vruthi-59a32.firebaseapp.com",
    databaseURL: "https://vruthi-59a32-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "vruthi-59a32",
    storageBucket: "vruthi-59a32.firebasestorage.app",
    messagingSenderId: "648102595952",
    appId: "1:648102595952:web:6031e2cd140d25166113b5",
    measurementId: "G-MS60MHWKMQ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const rtdb = getDatabase(app);
const analytics = getAnalytics(app);

export { auth, db, rtdb, analytics };
export default app;
